import { Wrapper } from './Introduction.styles';

import { IntroductionSections } from '@/components/IntrouctionSection';

export const Introduction = () => (
  <Wrapper>
    <IntroductionSections />
  </Wrapper>
);
